// Whether the visitor is signed in, known synchronously on first paint.
//
// ApplicationController pushes the current user into `gon` (see
// app/views/application/_gon.html.slim), so this is available before any XHR
// resolves -- it is null for anyone not signed in. Endpoints that only ever return
// data for a signed-in user can check this instead of firing a request that comes
// back empty, or 403 in the case of /api/notifications/recent.json.
//
// Deliberately not derived from /api/current_user.json: waiting on that would just
// serialise the requests rather than remove them.
export const isLoggedIn = (): boolean => {
  const gon = (window as any).gon;

  return Boolean(gon && gon.current_user);
};
